import axios from 'axios'
import fn from '../../utils/functions'

const state = {
  session: {
    list: []
  }
}

const getters = {
  userInformationList: state => state.session.list
}

const actions = {
  async getUserInformation ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/userinformation',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      commit('SET_USER_INFORMATION_LIST', response.data || [])
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async saveUserInformation ({ commit, rootState }, payload) {
    try {
      const request = {
        id: payload.id || null,
        message: payload.message,
        dateFrom: payload.dateFrom || null,
        dateTo: payload.dateTo || null
      }

      const response = await axios({
        method: 'POST',
        url: '/user/userinformation',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: request
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getHiddenUserInformation ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/user/userinformation/hidden',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data || []
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async saveUserInformationDisplay ({ commit, rootState }, { id, display }) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/user/userinformation/' + id + '/display',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: { display }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async deleteUserInformation ({ commit, rootState }, id) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/user/userinformation/' + id,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }
}

const mutations = {
  SET_USER_INFORMATION_LIST (state, list) {
    state.session.list = Array.isArray(list) ? list : []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
